import { render, staticRenderFns } from "./MppLogLogin.vue?vue&type=template&id=2544de0f&scoped=true&"
import script from "./MppLogLogin.vue?vue&type=script&lang=js&"
export * from "./MppLogLogin.vue?vue&type=script&lang=js&"
import style0 from "./MppLogLogin.vue?vue&type=style&index=0&id=2544de0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544de0f",
  null
  
)

export default component.exports